import { sudoStoreActions } from '@/store/actions'
import { NotificationState } from '@/store/notifications/notification'
import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { generateId } from '@repo/shared/uuid/uuid'

export function sudoCases(builder: ActionReducerMapBuilder<NotificationState>) {
  //
  // user
  //
  builder
    .addCase(
      sudoStoreActions.user.create.fulfilled,
      (
        state,
        {
          meta: {
            arg: { fields },
          },
        },
      ) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xCreated',
          descriptionTransOptions: {
            value: `${fields.firstName} ${fields.lastName}`,
          },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(
      sudoStoreActions.user.update.fulfilled,
      (state, { payload: { user } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xUpdated',
          descriptionTransOptions: {
            value: `${user.firstName} ${user.lastName}`,
          },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(
      sudoStoreActions.user.disable.fulfilled,
      (state, { payload: { user } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xDisabled',
          descriptionTransOptions: { value: user.email },
          icon: 'warn',
          id: generateId(),
        })
      },
    )
    .addCase(
      sudoStoreActions.user.enable.fulfilled,
      (state, { payload: { user } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xEnabled',
          descriptionTransOptions: { value: user.email },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(sudoStoreActions.user.updatePassword.fulfilled, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'xUpdated',
        descriptionTransOptions: { value: 'Password' },
        icon: 'check',
        id: generateId(),
      })
    })

  //
  // caseWorker
  //
  builder.addCase(sudoStoreActions.caseWorker.updateRole.fulfilled, (state) => {
    state.all.push({
      createdAt: new Date().getTime(),
      descriptionTransKey: 'caseWorkerRoleUpdated',
      icon: 'check',
      id: generateId(),
    })
  })

  //
  // organization
  //
  builder
    .addCase(
      sudoStoreActions.organization.create.fulfilled,
      (
        state,
        {
          meta: {
            arg: { name },
          },
        },
      ) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xCreated',
          descriptionTransOptions: { value: name },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(sudoStoreActions.organization.update.fulfilled, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'xUpdated',
        descriptionTransOptions: { value: 'Organization' },
        icon: 'check',
        id: generateId(),
      })
    })
    .addCase(sudoStoreActions.organization.hardDeleteOne.fulfilled, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'xDeleted',
        descriptionTransOptions: { value: 'Organization' },
        icon: 'check',
        id: generateId(),
      })
    })
}
